import { defineMessages } from 'react-intl-next';

export const i18n: {
	verifiedIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	verifiedIconTooltipMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	verifiedIconLabel: {
		id: 'search-page.verified-icon-label',
		defaultMessage: 'Verified',
		description: 'Label for the verified icon.',
	},
	verifiedIconTooltipMessage: {
		id: 'search-page.verified-icon-tooltip-message',
		defaultMessage: 'This page has been verified by an owner or admin.',
		description: 'Tooltip message for the verified icon.',
	},
});
